// Shared button configuration values without dependencies on model classes.
export enum ButtonSide {
  hidden,
  left,
  right,
  both,
}

export enum RockerConfig {
  rocker = "Rocker",
  single = "Single",
  disabled = "Disabled",
  none = "None",
}
